<div class="dialog">
    <div class="container">

        <button type="button" class="close" (click)="close()" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>

        <form [formGroup]="sponsorApplicationForm">
            <h2 style="color: #fff;">Fill Form</h2>
            <hr color="#fff">
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="email" style="color: #fff;">Select Property</label>
                        <select formControlName="prop" class="form-control">
                            <option value=""><img src="../../../../assets/images/bg.jpg" height="30px">
                                Please select Property</option>
                            <option [ngValue]="property_name" *ngFor="let property_name of ownerPropertiesData">
                                {{ property_name.propName }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col-md-6">

                    <div class="form-group">
                        <label for="email" style="color: #fff;">Email address</label>
                        <input formControlName="email" type="email" class="form-control" id="email" placeholder="email">
                    </div>
                </div>
            </div>


            <div class="row">

                <div class="col-md-6">
                    <div class="form-group">
                        <label for="url" style="color: #fff;">Your Website <small>Please include http://</small></label>
                        <input type="url" formControlName="website" class="form-control" id="url" placeholder="url">
                    </div>

                </div>

                <div class="col-md-6">

                    <div class="form-group">
                        <label for="phone" style="color: #fff;">Cell/Phone Number</label>
                        <input formControlName="phone" type="tel" class="form-control" id="phone" placeholder="phone">
                    </div>
                </div>
                <!--  col-md-6   -->
            </div>

            <!-- row -->
            <div class="row">
                <div class="col-md-6">
                    <div class="form-group">
                        <label style="color: #fff;">Attach Document </label><br>
                        <label class="custom-file-upload">
                            <input type="file" (change)="selectFile($event)" id="file" formControlName="attached_doc"
                                value="" class="file">
                            <!-- CHOOSE FILE -->
                        </label>
                        <p id="filename" style="color: #fff;">{{ file_name }}</p>
                        <button *ngIf="file_name" (click)="uploadDocument()" class="btn btn-success">UPLOAD</button>

                    </div>

                    <!-- <div class="alert alert-success" role="alert" *ngIf="uploadDocument()" style="margin: 10px;">
                        Successfully Uploaded
                    </div> -->
                </div>


            </div>

            <div class="row d-flex justify-content-center" *ngIf="isLoading">
                <img class="loader" src="../../../../assets/images/loader.gif" width="60px" alt="">
            </div>

            <div class="row d-flex justify-content-center">
                <div class="col-xs-6">
                    <button (click)="apply()" class="btn btn-primary m-b-1 submit_btn">Submit</button>
                </div>
            </div>

            <div class="row d-flex justify-content-center">
                <div class="alert alert-success" role="alert" *ngIf="successMessage" style="margin: 10px;">
                    {{ successMessage }}
                </div>
            </div>

            <div class="row d-flex justify-content-center" *ngIf="errorMessage">
                <div class="alert alert-danger" role="alert" style="margin: 10px;">
                    {{ errorMessage }}
                </div>
            </div>

            <div class="row d-flex justify-content-center" *ngIf="errorMessage" style="margin-top: 20px; color: #fff;">
                <p>Try Again</p>
            </div>

            <div class="row d-flex justify-content-center" *ngIf="errorMessage">
                <i  class="fa fa-repeat fa-4x"></i>
            </div>

        </form>
    </div>
</div>